import { render } from "./PersonalMessageList.vue?vue&type=template&id=6425a1f0&ts=true"
import script from "./PersonalMessageList.ts?vue&type=script&lang=ts&external"
export * from "./PersonalMessageList.ts?vue&type=script&lang=ts&external"

import "./PersonalMessageList.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__